var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97012 20.9997H20.0301C21.5701 20.9997 22.5301 19.3297 21.7601 17.9997L14.2301 4.98969C13.4601 3.65969 11.5401 3.65969 10.7701 4.98969L3.24012 17.9997C2.47012 19.3297 3.43012 20.9997 4.97012 20.9997ZM12.5001 13.9997C11.9501 13.9997 11.5001 13.5497 11.5001 12.9997V10.9997C11.5001 10.4497 11.9501 9.99969 12.5001 9.99969C13.0501 9.99969 13.5001 10.4497 13.5001 10.9997V12.9997C13.5001 13.5497 13.0501 13.9997 12.5001 13.9997ZM13.5001 17.9997H11.5001V15.9997H13.5001V17.9997Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.cfe9320bfcfd633520fc18f4eadb619d.svg";
export { ForwardRef as ReactComponent };